export const purpurGradientAiTextInteractivePrimary =
  "linear-gradient(289deg, #3694d3 -13%, #6d02a3 58%)";
export const purpurGradientAiTextInteractivePrimaryNegative =
  "linear-gradient(289deg, #62b2e7 -13%, #f4e0ff 58%)";
export const purpurGradientAiBackgroundInteractiveExpressive =
  "linear-gradient(291deg, #3694d3 -15%, #990ae3 44%)";
export const purpurGradientAiBackgroundInteractiveExpressiveNegative =
  "linear-gradient(291deg, #62b2e7 -15%, #990ae3 44%)";
export const purpurGradientAiBackgroundInteractivePrimary =
  "linear-gradient(291deg, #3694d3 -15%, #4e0174 44%, #b12df4 133%)";
export const purpurGradientAiBackgroundInteractivePrimaryNegative =
  "linear-gradient(280deg, #62b2e7 -15%, #f4e0ff 23%, #f4e0ff 68%, #d58df9 112%)";
export const purpurGradientAiBackgroundPrimaryNegative =
  "linear-gradient(352deg, #62b2e7 -69%, #1f002e 15%, #1f002e 87%, #d58df9 183%)";
export const purpurGradientAiBorderInteractivePrimary =
  "linear-gradient(289deg, #3694d3 -13%, #6d02a3 58%)";
export const purpurGradientAiBorderInteractivePrimaryNegative =
  "linear-gradient(289deg, #62b2e7 -13%, #f4e0ff 58%)";
